import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "./layout/Header";
import NavBar_appID from "./layout/NavBar_appID";
import Footer from "./layout/Footer";
import Button from "@mui/material/Button";
import { generateImmigrationBillPDF } from "../utility/services/immigration-bill";
import PDFBillInfoDialog from "./DialogComponent";
import { applicationManagement } from "../utility/services/apiService";
import { getAppId, getEmail } from "../utility/Common";
import ETDpdfDialog from "./ETDpdfDialogComponent";
import { messages } from "../utility/services/message";
import { createNotification } from "./Popup";
import ETDFormPdfDialog from "./etdFormDialog";
import { generateEtdFormBillPDF } from "../utility/services/form-printout";

function ApplicationStatus() {
  let navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openETDPdf, setOpenETDPdf] = useState(false);
  const [openETDFormPdf, setOpenETDFormPdf] = useState(false);
  const [openReceipt, setOpenReceipt] = useState(false);
  const [base64, setBase64] = useState();
  const [etdBase64, setEtdBase64] = useState();
  const [etdFile, setEtdFile] = useState();
  const [formEtdBase64, setFormEtdBase64] = useState();

  const [stageID, setstageID] = useState();
  const [appStatus, setAppStatus] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [isCheckingPayment, setICheckingPayment] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setOpenReceipt(false);
    setOpenETDPdf(false);
    setOpenETDFormPdf(false);
  };

  function openFormPDF(newData) {
    if (newData) {
      generateEtdFormBillPDF(newData)
        .then((base64Pdf) => {
          setFormEtdBase64(base64Pdf);
          setOpenETDFormPdf(true);
        })
        .catch((error) => {
          console.error("Error generating PDF:", error);
        });
    }
  }

  function openPDFBillINfo(newbill) {
    if (newbill) {
      generateImmigrationBillPDF(newbill)
        .then((base64Pdf) => {
          setBase64(base64Pdf);
          setOpen(true);
        })
        .catch((error) => {
          console.error("Error generating PDF:", error);
        });
    }
  }

  useEffect(() => {
    getApplicationStatus();
  }, []);

  function getApplicationStatus() {
    setIsLoading(true);
    const payload = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
    };
    applicationManagement(payload, "check_bill")
      .then((result) => {
        setIsLoading(false);
        if (result.code === 1 && result.data) {
          const stage = result.data[0]?.DocStageID;
          setstageID(stage);
          setAppStatus(result.data);
        } else if (result.code === 3) {
          sessionStorage.clear();
          localStorage.clear();
          navigate("/continue");
        } else {
          setstageID(140);
          setAppStatus([]);
          const info = { type: "error", message: result?.message };
          createNotification(info)();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        const info = { type: "error", message: messages.networkError };
        createNotification(info)();
      });
  }

  const getBillInfo = (item) => {
    const payload = {
      ApplicationId: item?.PayerID,
      EmailAddress: item?.PyrEmail,
    };
    applicationManagement(payload, "check_bill")
      .then((result) => {
        if (result?.data.length > 0) {
          openPDFBillINfo(result.data[0]);
        } else {
          const info = { type: "error", message: result?.message };
          createNotification(info)();
        }
      })
      .catch((error) => {
        const info = { type: "error", message: messages.networkError };
        createNotification(info)();
      });
  };

  function openETDPdfToprint(row) {
    setIsLoading(true);
    const payload = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
    };
    applicationManagement(payload, "print_out")
      .then((result) => {
        setIsLoading(false);

        if (result.code === 1) {
          setEtdFile(result.url);
          setEtdBase64(result.data);
          setOpenETDPdf(true);
        } else if (result.code === 3) {
          sessionStorage.clear();
          localStorage.clear();
          navigate("/continue");
        } else {
          const info = { type: "error", message: result?.message };
          createNotification(info)();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        const info = { type: "error", message: messages.networkError };
        createNotification(info)();
      });
  }

  function goToPrintForm(row) {
    setIsFormLoading(true);
    const payload = {
      ApplicationId: getAppId(),
      EmailAddress: getEmail(),
    };
    applicationManagement(payload, "get_etd_form")
      .then((result) => {
        if (result?.code == 1) {
          openFormPDF(result.data);
        } else {
          const info = { type: "error", message: result?.message };
          createNotification(info)();
        }
      })
      .catch((error) => {
        const info = { type: "error", message: messages.networkError };
        createNotification(info)();
      });
  }

  function checkPayments(item) {
    setICheckingPayment(true);
    const payload = {
      ApplicationId: item?.PayerID,
      EmailAddress: item?.PyrEmail,
    };
    applicationManagement(payload, "check_payment")
      .then((result) => {
        setICheckingPayment(false);
        if (result.code === 1 && result.data) {
          if (result?.data.length >= 0) {
            getApplicationStatus();
          } else {
            const info = { type: "error", message: result?.message };
            createNotification(info)();
          }
        }
      })
      .catch((error) => {
        setICheckingPayment(false);
        const info = { type: "error", message: messages.networkError };
        createNotification(info)();
      });
  }

  const endeleaBadae = () => {
    navigate("/");
  };
  const login = () => {
    navigate("/continue");
  };
  return (
    <>
      <Header />
      <div className="container">
        <NavBar_appID />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 tab-registration-menu hidden-xs">
                <div className="list-group">
                  <Link className="list-group-item done">Habari Binafsi</Link>
                  <Link className="list-group-item done">
                    Anuwani ya Makazi
                  </Link>
                  <Link className="list-group-item done">Habari za Wazazi</Link>
                  <Link className="list-group-item done">Habari za Safari</Link>
                  <Link className="list-group-item done">
                    Wakati wa Dharura
                  </Link>
                  <Link className="list-group-item done">Viambatanisho </Link>
                  <Link className="list-group-item done">Tamko Rasmi </Link>
                  <Link to="/stp10" className="list-group-item active">
                    Hali ya Ombi{" "}
                  </Link>
                  {stageID > 140 && (
                    <Link to="/billInfo" className="list-group-item">
                      Bili & Malipo
                    </Link>
                  )}
                </div>
              </div>
              <div
                className="col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-registration-tab"
                style={{ marginTop: "1px", paddingRight: "16px" }}
              >
                <div className="tab-registration-content active">
                  <div className="box box-default">
                    <br />
                    <p className="callout callout infoBar">
                      Kama utasubiri nambari ya malipo kwa muda bila kutokea
                      unatakiwa kubonyeza kitufe cha refresh ili upate namba ya
                      malipo ulipie.
                    </p>

                    <div className="table-responsive">
                    <table className="table table-striped custab" style={{ minWidth: "600px" }}>
                      <thead>
                        <tr>
                          <th style={{ width: "16%" }}>Nambari ya Ombi</th>
                          <th style={{ width: "13%" }}>Na. ya Malipo</th>
                          <th style={{ width: "26%" }}>Jina Kamil</th>
                          <th style={{ width: "20%" }}>Hali ya Ombi</th>
                          <th style={{ width: "*" }}>Kitendo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {appStatus &&
                          appStatus.map((item, index) => (
                            <tr key={index}>
                              <td style={{ verticalAlign: "middle" }}>
                                {item?.PayerID}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {item?.ControlNo ? item?.ControlNo : "Bado"}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {item?.FullName}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {item?.ClientNotification}
                              </td>

                              {/* <td style={{ verticalAlign: "middle" }}>
                                {item.DocStageID == 140 && (
                                  <Button
                                    type="button"
                                    onClick={() => getApplicationStatus()}
                                    className="showModalButton btn icon-btn btn-default"
                                    style={{ background: "#529ea9" }}
                                  >
                                    <span className="bi bi-upload img-circle text-muted"></span>{" "}
                                    <b style={{ color: "white" }}>
                                      {" "}
                                      {isLoading ? "Subiri.." : "Refresh"}
                                    </b>
                                  </Button>
                                )} */}

                              <td style={{ verticalAlign: "middle" }}>
                                {(item.DocStageID == 140 ||
                                  item.DocStageID == 300) && (
                                  <Button
                                    type="button"
                                    onClick={() => getApplicationStatus()}
                                    className="showModalButton btn icon-btn btn-default"
                                    style={{ background: "#1f2121" }}
                                  >
                                    <span className="bi bi-upload img-circle text-muted"></span>{" "}
                                    <b style={{ color: "white" }}>
                                      {" "}
                                      {isLoading ? "Subiri.." : "Refresh"}
                                    </b>
                                  </Button>
                                )}

                                {(item.DocStageID == 150 ||
                                  item.DocStageID == 130) && (
                                  <Button
                                    type="button"
                                    onClick={() => getBillInfo(item)}
                                    className="showModalButton btn icon-btn btn-default"
                                    style={{ background: "#529ea9" }}
                                  >
                                    <span className="bi bi-upload img-circle text-muted"></span>{" "}
                                    <b style={{ color: "white" }}>
                                      Angalia Bili
                                    </b>
                                  </Button>
                                )}

                                {item.DocStageID == 150 && (
                                  <Button
                                    type="button"
                                    onClick={() => checkPayments(item)}
                                    className="showModalButton btn icon-btn btn-default"
                                    style={{
                                      background: "#529ea9",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    <span className="bi bi-upload img-circle text-muted"></span>{" "}
                                    <b style={{ color: "white" }}>
                                      {isCheckingPayment
                                        ? "Subiri Kidogo.."
                                        : "Angalia malipo"}
                                    </b>
                                  </Button>
                                )}
                                {item.DocStageID === 600 && (
                                  <Button
                                    type="button"
                                    onClick={() => openETDPdfToprint(item)}
                                    className="showModalButton btn icon-btn btn-default"
                                    style={{
                                      background: "#529ea9",
                                      marginLeft: "5px",
                                    }}
                                    disabled={isLoading}
                                  >
                                    <span className="bi bi-upload img-circle text-muted"></span>{" "}
                                    <b style={{ color: "white" }}>
                                      {isLoading
                                        ? "Subiri Kidogo..."
                                        : "Printi Hati Yako"}
                                    </b>
                                  </Button>
                                )}

                                {item.DocStageID === 610 && (
                                  <Button
                                    type="button"
                                    onClick={() => openETDPdfToprint(item)}
                                    className="showModalButton btn icon-btn btn-default"
                                    style={{
                                      background: "#529ea9",
                                      marginLeft: "5px",
                                    }}
                                    disabled={isLoading}
                                  >
                                    <span className="bi bi-upload img-circle text-muted"></span>{" "}
                                    <b style={{ color: "white" }}>
                                      {isLoading
                                        ? "Subiri Kidogo..."
                                        : "Printi Hati Yako"}
                                    </b>
                                  </Button>
                                )}
                                {item.DocStageID === 620 && (
                                  <Button
                                    type="button"
                                    onClick={() => openETDPdfToprint(item)}
                                    className="showModalButton btn icon-btn btn-default"
                                    style={{
                                      background: "#529ea9",
                                      marginLeft: "5px",
                                    }}
                                    disabled={isLoading}
                                  >
                                    <span className="bi bi-upload img-circle text-muted"></span>{" "}
                                    <b style={{ color: "white" }}>
                                      {isLoading
                                        ? "Subiri Kidogo..."
                                        : "Printi Hati Yako"}
                                    </b>
                                  </Button>
                                )}

                                {item.DocStageID === 160 &&
                                  item.ApplicationFrom < 3 && (
                                    <Button
                                      type="button"
                                      onClick={() => checkPayments(item)}
                                      className="showModalButton btn icon-btn btn-default"
                                      style={{
                                        background: "#529ea9",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      <span className="bi bi-upload img-circle text-muted"></span>{" "}
                                      <b style={{ color: "white" }}>
                                        {isCheckingPayment
                                          ? "Subiri Kidogo.."
                                          : "Angalia malipo"}
                                      </b>
                                    </Button>
                                  )}

                                {item.DocStageID === 160 &&
                                  item.ApplicationFrom >= 3 && (
                                    <Button
                                      type="button"
                                      onClick={() => goToPrintForm()}
                                      className="showModalButton btn icon-btn btn-default"
                                      style={{
                                        background: "#529ea9",
                                        marginLeft: "5px",
                                      }}
                                      disabled={isLoading}
                                    >
                                      <span className="bi bi-upload img-circle text-muted"></span>{" "}
                                      <b style={{ color: "white" }}>
                                        {isLoading
                                          ? "Subiri Kidogo..."
                                          : "Chapisha Fomu Yako"}
                                      </b>
                                    </Button>
                                  )}

                                <PDFBillInfoDialog
                                  open={open}
                                  onClose={handleClose}
                                  row={base64}
                                />

                                <ETDpdfDialog
                                  open={openETDPdf}
                                  onClose={handleClose}
                                  row={etdFile}
                                />

                                <ETDFormPdfDialog
                                  open={openETDFormPdf}
                                  onClose={handleClose}
                                  row={formEtdBase64}
                                />
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    </div>
                  </div>
                  <div className="form-group field-passportsupportingdocs-applicationid">
                    <input
                      type="hidden"
                      id="ApplicationID"
                      className="form-control"
                      name="ApplicationID"
                      value="773067"
                    />
                    <p className="help-block help-block-error"></p>
                  </div>
                  <div className="box-footer">
                    <div className="row">
                      <div className="col-md-4">
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            login();
                          }}
                          to="/"
                          type=""
                          className="btn btn-labeled btn-block btn-default"
                        >
                          Endelea Baadae | <i className="fa fa-save"></i>
                        </Link>
                      </div>
                      <div className="col-md-4"></div>
                      <div className="col-md-4">
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            endeleaBadae();
                          }}
                          type="submit"
                          className="btn btn-default btn-block btn-label-next"
                          name="SaveNext"
                          value="SaveContinue"
                        >
                          Maliza |<i className="fa fa-angle-double-right"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
export default ApplicationStatus;
